/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Seo_TitleInputs */

const cs_blog_seo_title = /** @type {(inputs: Blog_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO titulek`)
};

const en_blog_seo_title = /** @type {(inputs: Blog_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO title`)
};

/**
* | output |
* | --- |
* | "SEO title" |
*
* @param {Blog_Seo_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_seo_title = /** @type {((inputs?: Blog_Seo_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Seo_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_seo_title(inputs)
	return cs_blog_seo_title(inputs)
});